var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section additional-sources"},[_vm._m(0),_c('AdditionalSourcesComponent',{key:_vm.schema.emissionSources.length,attrs:{"initialSchema":_vm.schema,"scope":_vm.scope}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activity-title-row"},[_c('h1',{staticClass:"activity-title"},[_vm._v("Additional Sources")]),_c('i',{staticClass:"title-icon fad fa-file-plus"})])
}]

export { render, staticRenderFns }